import clsx from 'clsx'
import ModalFrameHoc from 'components/Modal/modalFrameHoc'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Container, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'modules/Modals/NetworkText/network-text.module.scss'
import { FETCH_NETWORK_TEXT } from 'modules/Services/types'

const NetworkTextModal = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { textKey, UUID } = props

  const { texts, i18n } = useSelector((state) => ({
    texts: state['services/network'].texts,
    i18n: state['app'].i18n,
  }))

  const textObject = useMemo(() => {
    return texts.find((text) => text.key === textKey)
  }, [texts, textKey])

  useEffect(() => {
    if (!textObject) {
      dispatch({ type: 'MODAL/HIDE', payload: { UUID } })
      return
    }

    if (!textObject.text) {
      dispatch({
        type: FETCH_NETWORK_TEXT,
        payload: { ...props, params: { lang: i18n } },
      })
    }
  }, [])

  if (!textObject) {
    return null
  }

  return (
    <ModalFrameHoc {...props} noHeader showCloseButton={false}>
      {!textObject.text ? (
        <GridSpinner />
      ) : (
        <div>
          <Typography variant={'Header-70'}>{textObject.header}</Typography>
          <div
            className={clsx(styles['content'], styles['text-modal'])}
            dangerouslySetInnerHTML={{ __html: textObject.text }}
          />
          <Container display={'flex'} flexJustify={'flex-end'}>
            <Button
              size={'m'}
              bgColor="Label-GU-Primary"
              variant={'primary'}
              onClick={() => props.closeModal()}
            >
              {t('common::button_labels.got_it')}
            </Button>
          </Container>
        </div>
      )}
    </ModalFrameHoc>
  )
}

NetworkTextModal.propTypes = {
  key: PropTypes.string,
  closeModal: PropTypes.func,
  UUID: PropTypes.string,
  textKey: PropTypes.string,
}

export default NetworkTextModal
